module.exports = __webpack_public_path__ + "static/media/27OCHA15.13927db1.jpg";